import { FiSearch } from "react-icons/fi"
import { RiCloseFill } from "react-icons/ri"
import { AppSpan, AppText, CustomContainer, Divider, FixedPopup, FlexRow, Input, SidePopupContainer } from "src/style"


export const DisputeSearch: React.FC<any> = ({close}) => {
    
    return (
        <>
            <SidePopupContainer zIndex="7" onClick={close} bgColor='transparent' />
            <FixedPopup 
                padding="2" width="41.7" top="0" left="23" 
                data-aos="slide-up" style={{borderRight: '1px solid #E2E8F0'}}
                shadow="2px 0px 10px rgba(0, 0, 0, 0.1)"
            >
                <FlexRow justifyContent="space-between">
                    <CustomContainer 
                        width='32' radius='0.4' borderColor='#E2E8F0' 
                        leftPadding='1.5' rightPadding='1.5'
                        bgColor='#F7FAFC' rightMargin='1.5'
                    >
                        <FlexRow>
                            <FiSearch style={{fontSize: '2rem', color: '#A0AEC0'}} />
                            <Input 
                                height='3.6' leftPadding='1' placeholder='Search' color='#718096' 
                            />
                        </FlexRow>
                    </CustomContainer>
                    <AppSpan 
                        textSize="2.2" hoverColor="#E4405F"
                        onClick={close}
                    >
                        <RiCloseFill />
                    </AppSpan>
                </FlexRow>
                <CustomContainer topMargin="4" leftPadding="1">
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">My Open and Pending Tickets</AppText>
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">My Overdue Tickets</AppText>
                    <AppText hoverColor="#181D27" cursor="pointer">Urgent and High priority Tickets</AppText>
                </CustomContainer>
                <Divider margin="2" bgColor="rgba(226, 232, 240, 0.2)" />
                <CustomContainer leftPadding="1">
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">All Tickets</AppText>
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">All Unresolved tickets</AppText>
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">new and my open tickets</AppText>
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">Tickets I raised</AppText>
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">Tickets I’m mentioned in</AppText>
                    <AppText hoverColor="#181D27" cursor="pointer">Tickets I’m watching</AppText>
                </CustomContainer>
                <Divider margin="2" bgColor="rgba(226, 232, 240, 0.2)" />
                <CustomContainer leftPadding="1">
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">Archive</AppText>
                    <AppText bottomMargin="2.5" hoverColor="#181D27" cursor="pointer">Spam</AppText>
                    <AppText hoverColor="#181D27" cursor="pointer">Trash</AppText>
                </CustomContainer>
            </FixedPopup>
        </>
    )
}